import { createMeasurement, type MeasurementProps } from './createMeasurement';

export type VolumeProps = MeasurementProps<'capacity'>;

/**
 * A tank or reservoir capacity, in litres or gallons.
 *
 * Named for what a reader sees rather than for the `capacity` key it renders, following the unit
 * vocabulary the features already use.
 */
const Volume = createMeasurement('capacity', 'Volume');

export default Volume;
